import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, ArrowLeft, ArrowRight } from 'lucide-react';
import { productsAPI } from '../services/api';
import { useLanguage, pickLang } from '../i18n/LanguageContext';
import './Modal.css';

const ProductsPage = ({ category, onBack, onClose }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t, lang } = useLanguage();

  useEffect(() => { loadProducts(); }, [category]);

  const loadProducts = async () => {
    try {
      const res = await productsAPI.getByCategory(category.id);
      setProducts(res.data);
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      setLoading(false);
    }
  };

  const getPrimaryImage = (product) => {
    if (product.image_url) return product.image_url;
    if (product.images && product.images.length > 0) return product.images[0];
    return null;
  };

  const openProduct = (productId) => {
    onClose();
    navigate(`/product/${productId}`);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content products-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}><X size={24} /></button>

        <div className="modal-header">
          <button className="back-button" onClick={onBack}><ArrowLeft size={20} /> {t('common.back')}</button>
          <h2>{category.title}</h2>
        </div>

        <div className="modal-body">
          <div className="products-intro"><p>{category.description}</p></div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '3rem' }}><p>{t('common.loading')}</p></div>
          ) : products.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '3rem', color: '#999' }}>
              <p>—</p>
            </div>
          ) : (
            <div className="products-grid">
              {products.map((product) => {
                const img = getPrimaryImage(product);
                const name = pickLang(product, 'name', lang);
                return (
                  <div key={product.id} className="product-card-v2" data-testid={`product-card-${product.id}`}>
                    <div className="product-card-v2__image">
                      {img ? (
                        <img src={img} alt={name} loading="lazy" />
                      ) : (
                        <div className="product-card-v2__placeholder">—</div>
                      )}
                    </div>
                    <button
                      className="product-card-v2__cta"
                      onClick={() => openProduct(product.id)}
                      data-testid={`view-more-${product.id}`}
                    >
                      <span>{t('common.viewMore')}</span>
                      <ArrowRight size={16} />
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;
